<template>
<div>
  <snackbar></snackbar>

  <template v-if="!initialized || globalLoading">
    <v-progress-linear
      color="primary"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>
  </template>

  <template v-if="initialized">
    <template v-if="loggedIn">
      <component v-if="hasUserDialog" :is="userDialog.component" v-bind="userDialog.props"></component>
      <home v-show="!hasUserDialog" :k="k" @globalLoading="setGlobalLoading"></home>
    </template>

    <v-form @submit.prevent="login" v-else-if="initialized">
      <h1>{{ $t("Anmeldung") }}</h1>

      <p>{{ $t("Geben Sie Ihre E-Mail-Adresse ein und folgen Sie den Anweisungen in der E-Mail") }}.</p>

      <div>
        <v-text-field filled outlined v-model="email" name="email" :label="$t('E-Mail-Adresse')" type="text"></v-text-field>
        <v-btn color="primary" type="submit" large dark @click.prevent="login" :loading="loading">{{ $t("E-Mail verschicken") }}</v-btn>
      </div>
    </v-form>
  </template>
</div>
</template>

<script>
import Snackbar from "./utils/Snackbar";
import Home from "./Home";

export default {
  name: "Login",

  components: {
    Snackbar,
    Home
  },

  data: () => ({
    initialized: false,
    email: "",
    error: false,
    k: null,
    globalLoading: false
  }),

  computed: {
    loading() {
      return this.$store.state.loading;
    },

    loggedIn() {
      return this.$store.state.user.loggedIn;
    },

    loggedOut() {
      return this.$store.state.auth.loggedOut;
    },

    hasUserDialog() {
      if (this.$store.state.userDialog) {
        return true;
      }

      return false;
    },

    userDialog() {
      const userDialog = this.$store.state.userDialog;

      const res = {
        component: null,
        props: {}
      };

      if (!(userDialog instanceof Object)) {
        res.component = userDialog;
        return res;
      }

      res.component = userDialog.component;

      if ("props" in userDialog) {
        res.props = userDialog.props;
      }

      return userDialog;
    }
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const k = urlParams.get("k");
    if (k) {
      // do login
      this.$store.dispatch("auth/login", k).then(() => {
        this.k = k;
        this.initialized = true;
      }).catch(() => {
        this.$store.dispatch("userMessage", {
          type: "success",
          msg: "Es ist ein Fehler aufgetreten."
        });
        this.initialized = true;
      });
    } else {
      this.$store.dispatch("auth/me").finally(() => {
        this.initialized = true;
      });
      this.$store.dispatch("auth/start");
    }
  },

  beforeDestroy() {
    this.$store.dispatch("auth/destroy");
  },

  methods: {
    async login() {
      this.$store.dispatch("auth/email", this.email)
      .then((res) => {
        if (res.sent) {
          this.$store.dispatch("userMessage", {
            type: "error",
            msg: "Die E-Mail wurde verschickt."
          });
        } else {
          this.$store.dispatch("userMessage", {
            type: "success",
            msg: "Bitte überprüfen Sie Ihre E-Mail-Adresse."
          });
        }
      }).catch(() => {
        this.error = true;
      });
    },

    setGlobalLoading(loading) {
      this.globalLoading = loading;
    }
  },
};
</script>


